import useStyles from 'isomorphic-style-loader/useStyles';
import React from 'react';
import s from './index.less'

export default function AppQcode (props) {
    useStyles(s);
    
    return (
        <>
           {
                props.visible ?
                    <div className={`appQcode-box ${props.position || 'bottom'}`} >
                        <img src='http://static.hsdcyf.com/client/img/1726795897291.png' />
                        <div>扫码或在应用市场</div>
                        <div>搜索<span>"东楚优房"</span>下载</div>
                    </div>
            : <></>
        }  
    </>
        
    )
}